var map = {
	"./black/bofangluyin.png": "em6g",
	"./blue/bofangluyin.png": "Hqcs",
	"./white/bofangluyin.png": "FxXu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fRT0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/bofangluyin\.png$
// module id = fRT0
// module chunks = 24